<template>
  <div class="component-panel">
    <h3>Analyst Consensus</h3>
    <p>Shows Wall Street analyst ratings and price targets.</p>
  </div>
</template>
<script>
export default { name: 'AnalystConsensus' };
</script>
<style scoped>
.component-panel h3 { margin: 0 0 1rem 0; font-size: 1.2rem; font-weight: 700; }
.component-panel p { color: #64748b; }
</style> 